import { buildInboxQueryPath, DEFAULT_INBOX_FILTERS } from './inboxQuery.js';
import { formatInboxSender } from './inboxItemDisplay.js';

export interface MessageSearchItem {
  id: string;
  unread: boolean;
  message: {
    id: string;
    subject?: string | null;
    body?: string | null;
    channel: string;
    direction: string;
    metadata?: unknown;
    createdAt?: string | Date | null;
  };
  deal: {
    id: string;
    title: string;
    pipelineStage?: string | null;
  } | null;
  party?: {
    id: string;
    name?: string | null;
    email?: string | null;
    phone?: string | null;
    partyType?: string | null;
  } | null;
  assessment: {
    channelLabel: string;
    needsReview: boolean;
    reason: string;
  };
}

function clean(value?: string | null) {
  return typeof value === 'string' ? value.trim() : '';
}

function truncate(value: string, length = 120) {
  if (value.length <= length) return value;
  return `${value.slice(0, Math.max(0, length - 1)).trim()}...`;
}

export function buildMessageSearchPath(term: string, limit: number) {
  return buildInboxQueryPath({
    limit,
    searchQuery: term,
    sortMode: 'smart',
    filters: { ...DEFAULT_INBOX_FILTERS, workState: 'all' },
    // Universal search returns flat per-message hits, not grouped threads.
    includeThreadView: false,
  });
}

export function formatMessageSearchResult(item: MessageSearchItem) {
  const title = formatInboxSender({ party: item.party, message: item.message, fallback: 'Unknown sender' });
  const dealLabel = item.deal?.title ? item.deal.title : 'Needs review';
  const subject = clean(item.message.subject);
  const body = clean(item.message.body);
  const preview = truncate([subject, body].filter(Boolean).join(' - ') || 'No message body');

  return {
    title,
    subtitle: `${item.assessment.channelLabel} - ${dealLabel}`,
    preview,
    needsReview: item.assessment.needsReview,
  };
}

export function messageSearchHref(item: MessageSearchItem) {
  return item.deal ? `/deals/${item.deal.id}` : '/inbox';
}
